import {Component, OnInit, ViewChild} from '@angular/core';
import {ReactiveFormsModule, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {combineLatest, Observable} from 'rxjs';
import {User} from '@services/model/user';
import {SearchUserParams, VoilaUserService} from '@services/voila-user.service';
import {map, share, startWith, tap} from 'rxjs/operators';
import {MatPaginator} from '@angular/material/paginator';
import {HandelspartnerResource} from '@services/resource/handelspartner-resource';
import {MatSort} from '@angular/material/sort';
import {UserPrivilege} from '@services/resource/user-privilege';
import {UserType} from '@services/resource/user-type';
import {ContinuousActionComponent} from '@widgets/continuous-action/continuous-action.component';
import {MatCard, MatCardContent, MatCardTitle} from '@angular/material/card';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {EditUserComponent} from '@ma-dashboard/users/edit/edit-user.component';
import {MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTable} from '@angular/material/table';
import {MatOption} from '@angular/material/core';
import {MatSelect} from '@angular/material/select';
import {CommonModule} from '@angular/common';
import {MatInput} from '@angular/material/input';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatCard,
    MatCardTitle,
    ContinuousActionComponent,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatPaginator,
    EditUserComponent,
    MatTable,
    MatCardContent,
    MatOption,
    MatSelect,
    MatHeaderCellDef,
    MatCellDef,
    MatRowDef,
    MatHeaderRowDef,
    MatInput,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatRow,
  ],
})
export class UserListComponent implements OnInit {
  constructor(private readonly userService: VoilaUserService) {}

  form = new UntypedFormGroup({
    text: new UntypedFormControl(),
    userType: new UntypedFormControl(),
    userPrivilege: new UntypedFormControl(),
  });

  @ViewChild(MatPaginator, {static: true})
  paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('loading', {static: true}) continuousActionComponent: ContinuousActionComponent;

  total$: Observable<number>;
  users$: Observable<User[]>;
  selectedUser: HandelspartnerResource | undefined;
  UserPrivilege = UserPrivilege;
  UserType = UserType;
  dialogState = false;

  displayedColumns = ['name', 'email', 'usertype', 'role', 'mnetId'];

  ngOnInit() {
    this.dialogState = false;
    this.selectedUser = undefined;

    const page$ = this.paginator.page.pipe(
      tap(() => window.scrollTo(0, 0)),
      startWith({pageIndex: 0, pageSize: 25}),
    );

    const search$ = this.form.valueChanges.pipe(
      map((x) => x.text),
      startWith(null),
    );

    const result$ = combineLatest([search$, page$]).pipe(
      map(
        (x) =>
          new SearchUserParams(x[0], x[1].pageIndex * x[1].pageSize, x[1].pageSize, this.form.get('userType')?.value, this.form.get('userPrivilege')?.value),
      ),
      this.continuousActionComponent.actions((params) => this.userService.searchUser(params)),
      share(),
    );

    this.users$ = result$.pipe(map((x) => x.users));
    this.total$ = result$.pipe(map((x) => x.total));
  }

  openUserModal(h: HandelspartnerResource) {
    this.selectedUser = h;
    this.dialogState = true;
  }

  closeDialog() {
    this.selectedUser = undefined;
    this.dialogState = false;
    this.form.updateValueAndValidity();
  }

  /* Changes filters if change would be illogical (IP with privileges for example) */
  updateFilters() {
    const userPrivilegeSelect = this.form.get('userPrivilege');
    const userTypeSelect = this.form.get('userType');
    if (userTypeSelect?.value == 'HP' || userTypeSelect?.value == 'IP') {
      userPrivilegeSelect?.reset();
      userPrivilegeSelect?.disable();
      this.displayedColumns = ['name', 'email', 'usertype', 'mnetId'];
    } else {
      userPrivilegeSelect?.enable();
      this.displayedColumns = ['name', 'email', 'usertype', 'role', 'mnetId'];
    }
  }
}
